import React, { Component } from "react";
import Company from "./company";

import { TextField, Loadable } from "components/support";

class Companies extends Component {
  static defaultProps = {
    id: ""
  };

  handleClick = company => {
    this.props.onSelectCompany(company);
  };

  handleFilter = (event, value) => {
    this.props.onFilter(value);
  };

  render() {
    return (
      <div id={this.props.id} className="companies">
        <TextField
          fullWidth
          autoFocus
          placeholder="Pesquisar"
          value={this.props.filterValue}
          onChange={this.handleFilter}
        />
        <Loadable loading={this.props.loading}>
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            {this.props.companies.map(v => (
              <Company key={v.uuid} info={v} onClick={this.handleClick} />
            ))}
          </div>
        </Loadable>
      </div>
    );
  }
}

export default Companies;



// WEBPACK FOOTER //
// ./src/components/support/companies/index.js